/* eslint-disable react-hooks/exhaustive-deps */
import styles from "../css/SetupForm.module.css";
import { useContext } from "react";
import { openDB } from "idb";
import Context from "../context/context";
const CheckboxInput = ({ name, children, invoiceFieldCustomization, handleCheckboxChange }) => (
  <label className={styles.checkboxLabel}>
    <input
      name={name}
      type="checkbox"
      checked={invoiceFieldCustomization?.[name] === "1"}
      onChange={handleCheckboxChange}
    />
    {children}
  </label>
);

export default function InvoiceFieldCustomizationForm({
  invoiceFieldCustomization,
  setInvoiceFieldCustomization,
  setCustomizationModalOpen,
  invoiceSetup
}) {
  const context = useContext(Context);
  const { updateUnSync } = context;

  const handleCheckboxChange = (event) => {
    const { checked, name } = event.target;
    setInvoiceFieldCustomization({
      ...invoiceFieldCustomization,
      [name]: checked ? "1" : "0",
    });
  };

  const handleSelectChange = (event) => {
    const { value, name } = event.target;
    setInvoiceFieldCustomization({
      ...invoiceFieldCustomization,
      [name]: parseInt(value),
    });
  };

  const checkboxArgs = {
    invoiceFieldCustomization,
    setInvoiceFieldCustomization,
    handleCheckboxChange,
  };

  const formSubmits = async (e) => {
    e.preventDefault();

    const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    let outlet = (await outletStore.getAll())[0];

    const updatedSetup = await {
      ...invoiceSetup,
      invoice_field_customization: {
        ...invoiceSetup.invoice_field_customization,
        ...invoiceFieldCustomization,
      }
    }

    const invoice_setup = await outlet.invoice_setup?.filter(i => i.brand_uuid !== invoiceSetup.brand_uuid) || []
    await invoice_setup.push({ ...updatedSetup })
    outlet = await { ...outlet, invoice_setup }
    
    await outletStore.put(outlet);
    handleInvoiceUnsyncedFile(outlet);
    setCustomizationModalOpen(false);
  };

  // Adding/Editing  outlet details to unsynced_files collection in IndexedDB
  const handleInvoiceUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "invoice_setup",
      RECON_TIME: Date.now(),
      invoice_setup: data.invoice_setup,
    };
    await tx.put(ndata);
    handleInvoiceReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing invoice to reconciliation collection in IndexedDB
  const handleInvoiceReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "others");
    if (othersJsonExists) {
      const invoice = othersJsonExists?.details?.filter((entry) => entry.type !== 'invoice_setup')
      const editData = {
        ...othersJsonExists,
        details: [
          ...invoice,
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData)
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: 'invoice_setup',
            RECON_TIME: data.RECON_TIME,
          },
        ]
      };
      await tx.add(newdata);
    }
  }

  return (
    <div className={styles.form}>
      <div className={styles.heading}>
        <h1>Invoice Field Customization</h1>
      </div>

      <div className={styles.formContainer}>
        <div className={styles.formGroup}>
          <h2>Header Printing Options</h2>
          <div className={styles.row}>
            <CheckboxInput name="seat" {...checkboxArgs}>
              Seat
            </CheckboxInput>
            <CheckboxInput name="ticket_number" {...checkboxArgs}>
              Ticket Number
            </CheckboxInput>
            <CheckboxInput name="order_number" {...checkboxArgs}>
              Order Number
            </CheckboxInput>
            <CheckboxInput name="date" {...checkboxArgs}>
              Date
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name="time" {...checkboxArgs}>
              Time
            </CheckboxInput>
            <CheckboxInput name="payment_mode" {...checkboxArgs}>
              Payment Mode
            </CheckboxInput>
            <CheckboxInput name="cashier" {...checkboxArgs}>
              Cashier
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Name Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name="customer_name_dinein" {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name="customer_name_takeaway" {...checkboxArgs}>
              Take Away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name="customer_name_delivery" {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name="customer_name_zomato" {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name="customer_name_swiggy" {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Mobile Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name="customer_mobile_dinein" {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name="customer_mobile_takeaway" {...checkboxArgs}>
              Take away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name="customer_mobile_delivery" {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name="customer_mobile_zomato" {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name="customer_mobile_swiggy" {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Customer Address Printing</h2>
          <div className={styles.row}>
            <CheckboxInput name="customer_address_dinein" {...checkboxArgs}>
              Dine in Order
            </CheckboxInput>
            <CheckboxInput name="customer_address_takeaway" {...checkboxArgs}>
              Take away / Pickup Orders
            </CheckboxInput>
            <CheckboxInput name="customer_address_delivery" {...checkboxArgs}>
              Delivery Orders
            </CheckboxInput>
          </div>
          <div className={styles.row}>
            <CheckboxInput name="customer_adress_zomato" {...checkboxArgs}>
              Zomato Orders
            </CheckboxInput>
            <CheckboxInput name="customer_adress_swiggy" {...checkboxArgs}>
              Swiggy Orders
            </CheckboxInput>
          </div>
        </div>

        <div className={styles.formGroup}>
          <h2>Other Printing Options</h2>

          <div className={styles.row}>
            <CheckboxInput name="serial_number_in_items" {...checkboxArgs}>
              Serial No. in Items
            </CheckboxInput>

            <CheckboxInput name="total_item_quantity" {...checkboxArgs}>
              Total Item Qty
            </CheckboxInput>
          </div>

          <div className={styles.row}>
            <label className={styles.selectLabel} style={{ width: "50%" }}>
              Item Display
              <select
                name="item_display_type"
                className={styles.select}
                style={{ width: "100%" }}
                value={invoiceFieldCustomization?.item_display_type}
                onChange={handleSelectChange}
              >
                <option value={0}>Merged</option>
                <option value={1}>Ticket Wise</option>
                <option value={2}>Ticket Wise with Details</option>
              </select>
            </label>

            <label className={styles.selectLabel} style={{ width: "50%" }}>
              Multi Serving Display
              <select
                name="multi_serving_display"
                className={styles.select}
                style={{ width: "100%" }}
                value={invoiceFieldCustomization?.multi_serving_display}
                onChange={handleSelectChange}
              >
                <option value={0}>Same Line</option>
                <option value={1}>Another Line</option>
              </select>
            </label>
          </div>
        </div>
        <button className={styles.submit} onClick={formSubmits}>
          Save changes
        </button>


      </div>

    </div>
  );
}
